import { clientRuntimeConfig } from '@grandstand-web/utils/config'

export const isConnectedWeb = () => clientRuntimeConfig.appName === 'connected-web'
